/**
 * specify cmd else 'any' is assumed
 * @param cmd 
 */
export const validatePluginMsg = (cmd?) => {
    let validateMessage = "{'enrollType':'any','validatePlugin':'true'}";
    if (cmd) {
        validateMessage = "{'enrollType':'" + cmd + "','validatePlugin':'true'}";
    }
    return validateMessage;
};